import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Flashcards from "@/pages/Flashcards";
import Exam from "@/pages/Exam";
import Antiseche from "@/pages/Antiseche";
import Import from "@/pages/Import";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/flashcards" element={<Flashcards />} />
          <Route path="/exam" element={<Exam />} />
          <Route path="/antiseche" element={<Antiseche />} />
          <Route path="/import" element={<Import />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
